exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* ANIMATION */\n/* SHADOWS */\n.Bookmark__bookmark__1q4A2 {\n  font-size: 19px; }\n\n.Bookmark__input-group-addon__1Vj93 {\n  cursor: pointer;\n  padding-top: 0; }\n  .Bookmark__input-group-addon__1Vj93 i {\n    font-size: 18px;\n    color: #000000; }\n", ""]);

// exports
exports.locals = {
	"bookmark": "Bookmark__bookmark__1q4A2",
	"input-group-addon": "Bookmark__input-group-addon__1Vj93"
};